import * as constants from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  deliveryAddress: {},
};

const addressReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.REQUEST_ADDRESS:
      return {
        ...state,
        isLoading: true,
        //error: null,
      };
    case constants.RECEIVE_ADDRESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        //deliveryAddress: action.payload,
      };
    case constants.RECEIVE_ADDRESS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case constants.UPDATE_DELIVERY_ADDRESS:
      return {
        ...state,
        deliveryAddress: action.payload,
      };
    default:
      return state;
  }
};

export default addressReducer;